import { useFormikContext } from "formik";
import Alias from "@/components/Alias";
import { OrganizationWebsite } from "../OrganizationWebsite";
import { useResponsive } from "@/hooks";

const WebsiteAccess = () => {
  const { values, setFieldValue } = useFormikContext<OrganizationWebsite>();
  const { isExtraSmall } = useResponsive();

  const handleChange = (value: string) => {
    setFieldValue("organization.alias", value);
  };

  return (
    <Alias
      isVerified
      value={values?.organization?.alias ?? ""}
      onChange={handleChange}
      sx={{
        ".field-container": {
          border: "2px solid #00000025",
          ...(isExtraSmall
            ? {
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                borderBottom: "none",
              }
            : {
                borderTopLeftRadius: 12,
                borderBottomLeftRadius: 12,
                borderRight: "none",
              }),
        },
        ".alias-input .MuiOutlinedInput-root": {
          backgroundColor: "transparent",
          border: "2px solid #00000025",
          ...(isExtraSmall
            ? {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }
            : {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
              }),
        },
      }}
    />
  );
};

export default WebsiteAccess;
